module.exports = __webpack_public_path__ + "media/images/reseller-cover-47c7e97ae9fcd369090b78e9ebebc808.jpg";